module.exports = __webpack_public_path__ + "img/czsc_16.a0a559f6.png";